import {
  AddListingToTourModal,
  OnboardingWelcomeModal,
  SetupBrokerageWizardModal,
  OnboardingPreLaunchModal,
  UserSuggestedUpdateModal,
  FeedbackModal,
  AppointmentActionModal,
  ContextualChatModal,
} from 'modals';
import type { TLegacyDialogKey } from './DialogStore.types';

export const getLegacyDialogMapper = (key: TLegacyDialogKey) => {
  switch (key) {
    case 'AddListingToTourModal':
      return AddListingToTourModal;
    case 'OnboardingWelcomeModal':
      return OnboardingWelcomeModal;
    case 'SetupBrokerageWizardModal':
      return SetupBrokerageWizardModal;
    case 'OnboardingPreLaunchModal':
      return OnboardingPreLaunchModal;
    case 'UserSuggestedUpdateModal':
      return UserSuggestedUpdateModal;
    case 'FeedbackModal':
      return FeedbackModal;
    case 'AppointmentActionModal':
      return AppointmentActionModal;
    case 'ContextualChatModal':
      return ContextualChatModal;
    default:
      return null;
  }
};
